import { TenantRoute } from "../components/ProtectedRoute";
import TenantPortalLayout from "../components/TenantPortalLayout";

export default [TenantRoute, TenantPortalLayout];